import {Injectable} from '@angular/core';
import momentLib from 'moment/moment';
// TB: Workaround für moment.js: als locale wird egal was man setzt immer 'en' gesetzt, der import behebt dieses problem
import 'moment/locale/de';
import {Moment, MomentBuiltinFormat, MomentFormatSpecification, MomentInput} from 'moment';

interface IPartialDateFormats {
  [localeId: string]: string[];
}

@Injectable()
export class MomentService {
  public partialDateFormats: IPartialDateFormats = {
    de: ['DDD', 'DD.MMM', 'DD.0', 'D.0', 'MM', 'D.', 'D.M', 'D.M.', 'D.M.Y', 'D.M.YY',
      'D.MM.YYYY', 'D.M.YYYY', 'DDMM.YYYY', 'DD.MMYYYY', 'DD.', 'DD.M', 'DD.M.', 'DD.MM', 'DD.MM.', 'DD.M',
      'DDM', 'DDMM', 'DDMMY', 'DDMMYY', 'DDMMYYY', 'DDMMYYYY'],
  };

  public validDateFormat: string | any[] = ['L', 'l', 'YYYY-MM-DD', 'DDMMYYYY'];

  constructor() {
    // TODO maybe determine client's locale?
    momentLib.locale('de');
  }

  public moment(inp?: MomentInput, format?: MomentFormatSpecification, strict?: boolean): Moment {
    return momentLib(inp, format, strict).hour(12);
  }

  public momentWithoutDelay(): Moment {
    return momentLib();
  }

  public getIso8601Format(): MomentBuiltinFormat {
    return momentLib.ISO_8601;
  }
}
